import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class PropertyBlockActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Property/PropertyBlock/PropertyBlockBrowser")
	}

	render() {
		return (
			<Activity 
				name="PropertyBlock"
				RenderedComponent={this.RenderedComponent}
				context="PropertyBlock"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(PropertyBlockActivity)
